export enum ELegalEntityTypes {
  individual = 'individual',
  organisation = 'organisation',
}
export enum ELegalEntityTypesName {
  individual = 'Individual',
  organisation = 'Organisation',
}

export enum ELegalEntityTypesLabel {
  individual = 'individual',
  organisation = 'organisation',
}

export enum LETypes {
  individual = 'INDIVIDUAL',
  organization = 'ORGANIZATION',
}

export enum LEModuleTypes {
  individual = 'INDIVIDUAL',
  organisation = 'ORGANISATION',
}
